
import React, { useEffect } from "react";
import Box from '@mui/material/Box';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import { useSelector } from "react-redux";

export default function DropDownForTimeSelection(props) {

    const { selectedTimeRangeForUIShow, selectedStartDate } = useSelector((state) => state.createOrderSlice)


    const { options, onChange, disableCondition, error } = props;
    function timeRangeSelectionFormat(timeRange) {
        // Format start time
        const startHour = timeRange?.startTime?.hours < 10 ? `0${timeRange?.startTime?.hours}` : timeRange?.startTime.hours;
        const startMinutes = timeRange?.startTime?.minutes === 0 ? '00' : '30';
        const formattedStartTime = `${startHour}:${startMinutes}`;

        // Format end time
        const endHour = timeRange?.endTime?.hours < 10 ? `0${timeRange?.endTime?.hours}` : timeRange?.endTime?.hours;
        const endMinutes = timeRange?.endTime?.minutes === 0 ? '00' : '30';
        const formattedEndTime = `${endHour}:${endMinutes}`;

        // Create option value
        const optionValue = `${formattedStartTime} - ${formattedEndTime}`;
        return optionValue;
    }
    return (
        <Box sx={{ minWidth: 120 }} className={`w-100`}>
            <FormControl fullWidth>
                {/* <InputLabel id="demo-simple-select-label">{label}</InputLabel> */}
                <Select
                    labelId="demo-simple-select-label"
                    // onChange={(e) => onChange(e.target.value)}
                    disabled={disableCondition}
                    value={selectedTimeRangeForUIShow ? selectedTimeRangeForUIShow?.id : "Select Time Range"}
                >
                    <MenuItem style={{ display: "none" }} onClick={() => { }} value={"Select Time Range"}>Select Time Range</MenuItem>

                    {options?.map((timeRange, index) => {


                        return (

                            <MenuItem onClick={() => onChange(timeRange)} key={index} value={timeRange?.id}>{timeRangeSelectionFormat(timeRange)}</MenuItem>
                        );
                    })}

                </Select>
                {error ? !selectedStartDate && <p className='form-error-message'>This field is required</p> : null}

            </FormControl>
        </Box>
    );


}


